"use client";

import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import API from "../../api";

const WhyChooseUs = () => {
  const [reasonsList, setReasonsList] = useState([]);
  const [statsList, setStatsList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };

    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.get("/api/why-choose");
        const allData = response.data.data;

        const reasons = allData
          .filter((item) => item.contentType === "reason")
          .sort((a, b) => (a.order || 0) - (b.order || 0));

        const stats = allData
          .filter((item) => item.contentType === "stat")
          .sort((a, b) => (a.order || 0) - (b.order || 0));

        setReasonsList(reasons);
        setStatsList(stats);
      } catch (error) {
        console.error("Error fetching WhyChooseUs data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const renderIcon = (iconName) => {
    const IconComponent = FaIcons[iconName] || FaIcons.FaAward;
    return <IconComponent />;
  };

  if (isLoading) return null;

  return (
    <section className="pb-12 md:pb-12 bg-white">

      <div className="max-w-7xl mx-auto px-6 md:px-10">

        <div className="flex flex-col lg:flex-row items-start gap-16">

          {/* LEFT */}
          <div className="w-full lg:w-1/2">

            <span className="text-[#B08D57] uppercase tracking-[0.35em] text-[11px] font-semibold mb-4 block">
              {lang === "en" ? "Why Choose Rigors" : "为什么选择 Rigors"}
            </span>

            <h2 className="text-[30px] md:text-[38px] leading-tight text-[#1A1A1A] font-century mb-6">
              {lang === "en"
                ? "Your Partner in Growth & Compliance"
                : "您在 增长与合规 方面的伙伴"}
            </h2>

            <div className="space-y-5">
              {reasonsList.map((item) => (
                <div key={item._id} className="flex gap-5">

                  {/* ICON */}
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A1A1A] text-white text-lg shrink-0">
                    {renderIcon(item.iconName)}
                  </div>

                  {/* TEXT */}
                  <div>
                    <h4 className="text-[16px] font-semibold text-[#1A1A1A] mb-2">
                      {item.title?.[lang]}
                    </h4>

                    <p className="text-[14px] md:text-[15px] text-[#999999] leading-relaxed max-w-[90%]">
                      {item.description?.[lang]}
                    </p>
                  </div>

                </div>
              ))}
            </div>

          </div>

          {/* RIGHT */}
          <div className="w-full lg:w-1/2">

            <div className="p-10 bg-[#999999]/10 rounded-[6px]">

              <div className="space-y-8">
                {statsList.map((stat, index) => (
                  <div
                    key={stat._id}
                    className={`${index !== 0 ? "pt-6 border-t border-[#e5e5e5]" : ""}`}
                  >
                    <h3 className="text-4xl md:text-5xl font-bold text-[#1A1A1A]">
                      {stat.title?.[lang]}
                    </h3>

                    <p className="text-[11px] tracking-[0.3em] uppercase text-[#B08D57] font-semibold mt-3">
                      {stat.description?.[lang]}
                    </p>
                  </div>
                ))}
              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default WhyChooseUs;